import { gql } from '@apollo/client';

export const ApplyWeightedCapitalizedPercentToContributorsResultFragment = gql`
  fragment ApplyWeightedCapitalizedPercentToContributorsResult on ApplyWeightedCapitalizedPercentageToContributorsResult {
    success
  }
`;
